import React from "react";
import FormColumn from "./FormColumn";

const SignupCompany = () => {
  return <FormColumn />;
};

export default SignupCompany;
